export type HttpErrorClass = "4xx" | "5xx" | "unknown";

export const getHttpErrorClass = (status?: number): HttpErrorClass => {
  if (status && status >= 400 && status < 500) {
    return "4xx";
  }

  if (status && status >= 500 && status < 600) {
    return "5xx";
  }

  return "unknown";
};
